import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { CompanyApprovalService } from '../../services/company-approval-service';
import * as fs from 'file-saver';
import { SharedService } from 'src/app/shared/services';
import { Router } from '@angular/router';
@Component({
  selector: 'app-vendor-profile-status',
  templateUrl: './vendor-profile-status.component.html',
  styleUrls: ['./vendor-profile-status.component.css']
})
export class VendorProfileStatusComponent implements OnInit {
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  startSearch: boolean = false;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  matchModeOptionsForDropdown: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  showToggle:boolean;
  gridGlobalFilter: SelectItem[];
  showTopFilters: boolean;
  isSearchLoading: boolean = false;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  vendorProfileStatusSearchParam:IGlobalSearchParam;
  isshowpaginator:boolean=true;
  vendorProfileStatusSearchSpinner = 'userApprovalSearchSpinner';
  vendorProfileStatusList;
  loading: boolean = false;
  showAddRuleButtonCO:boolean = false;
  showAddRuleButtonMO:boolean = false;
  completionSearchValues:any;
  public selectedCompanyProfileStatusId:Array<any> = [];
  public selectedCompanyDetailStatusId:Array<any> = [];
  public selectedDeliveryTeamStatusId:Array<any> = [];
  public selectedReferenceStatusId:Array<any> = [];
  public selectedAdminDetailStatusId:Array<any> = [];
  public selectedOnboardingDocumentStatusId:Array<any> = [];
  selectedCompanyProfileStatus:any
  selectedCompanyDetailStatus:any;
  selectedDeliveryTeamStatus:any;
  selectedReferenceStatus:any;
  selectedAdminDetailStatus:any;
  selectedOnboardingDocumentStatus:any;
  companyProfileStatus:any;
  companyDetailStatus:any;
  deliveryTeamStatus:any;
  referenceStatus:any;
  adminDetailStatus:any;
  onboardingDocumentStatus:any;
  allColumns = [
    { value: 'companyName', header: 'Vendor Name' },
    { value: 'adminName', header: 'Admin Name' },
    { value: 'adminEmail', header: 'Admin Email' },
    { value: 'adminPrimaryPhone', header: 'Admin Phone' },
    { value: 'hasCompProfileCompleted', header: 'Company Profile' },
    { value: 'hasCompDetailsCompleted', header: 'Company Details' },
    { value: 'hasDeliveryTeamsCompleted', header: 'Delivery Teams' },
    { value: 'hasReferenceCompleted', header: 'Reference' },
    { value: 'hasAdminDetailsCompleted', header: 'Admin Details' },
    { value: 'hasOnboardDocsCompleted', header: 'Onboarding Documents' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedOn', header: 'Modified On' },
    { value: 'createdByName', header: 'Created By' },
  
  ]

  selectedColumns = [
    { value: 'companyName', header: 'Vendor Name' },
    { value: 'adminName', header: 'Admin Name' },
    { value: 'adminEmail', header: 'Admin Email' },
    { value: 'adminPrimaryPhone', header: 'Admin Phone' },
    { value: 'hasCompProfileCompleted', header: 'Company Profile' },
    { value: 'hasCompDetailsCompleted', header: 'Company Details' },
    { value: 'hasDeliveryTeamsCompleted', header: 'Delivery Teams' },
    { value: 'hasReferenceCompleted', header: 'Reference' },
    { value: 'hasAdminDetailsCompleted', header: 'Admin Details' },
    { value: 'hasOnboardDocsCompleted', header: 'Onboarding Documents' },
    { value: 'createdByName', header: 'Created By' },
  ]
  @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private companyApprovalService:CompanyApprovalService,
    public sharedService:SharedService,
    private _router: Router,
    public datePipe: DatePipe,
  ) {
    this.showFilters = false;
      this.showSorting = false;
      this.spinner.show();
      setTimeout(() => {
          this.spinner.hide();
      }, 1000);
   }

  ngOnInit(): void {
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";

    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];
    this.matchModeOptionsForDropdown = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
    ];
    this.filterCondition=[
      {fieldName:"companyName",type:"basic"},
      {fieldName:"adminName",type:"basic"},
      {fieldName:"adminEmail",type:"basic"},
      {fieldName:"adminPrimaryPhone",type:"basic"},
      {fieldName:"hasCompProfileCompleted",type:"dropdown"},
      {fieldName:"hasCompDetailsCompleted",type:"dropdown"},
      {fieldName:"hasDeliveryTeamsCompleted",type:"dropdown"},
      {fieldName:"hasReferenceCompleted",type:"dropdown"},
      {fieldName:"hasAdminDetailsCompleted",type:"dropdown"},
      {fieldName:"hasOnboardDocsCompleted",type:"dropdown"},
      {fieldName:"createdOn",type:"date"},
      {fieldName:"modifiedOn",type:"date"},
      {fieldName:"createdByName",type:"basic"},
     
    ];
 this.getVendorProfileStatusList();
 //this.applyFilter();
   this.completionSearchValues=['All','Yes','No'];
   
   this.checkViewPermission();
  }

  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }
  getVendorProfileStatusList()
  {
    this.vendorProfileStatusSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.vendorProfileStatusSearchSpinner);
    this.companyApprovalService.getVendorProfileStatusList(this.vendorProfileStatusSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.vendorProfileStatusList =data;
      this.isshowpaginator=this.vendorProfileStatusList.length>0?true:false;
      console.log(data);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.vendorProfileStatusSearchSpinner);
     });
  }
  
  setColumnWidth(value) {
    if (this.showFilters == true && this.showSorting == true) {
      return value + 4 + 'rem'
    } else if (this.showFilters == true || this.showSorting == true) {
      return value + 2 + 'rem'
    }
    else {
      return value + 'rem'
    }
  }

  loadVendorProfileStatusList(event:LazyLoadEvent)
  { 
    this.appliedFilters = [];
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getVendorProfileStatusList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonCO = true;
    }
    else{
      this.showAddRuleButtonCO = false;
    }
    }
    if(this.filters["modifiedOn"]!= undefined)
    {
    if(this.filters["modifiedOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonMO = true;
    }
    else{
      this.showAddRuleButtonMO = false;
    }
    }
   
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getVendorProfileStatusList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }
  applyFilterNew(table: Table){
    this.filters=table.filters;
    console.log(this.filters);
    this.applyFilter();
  }
  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }
  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }
  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.selectedCompanyProfileStatus ="";
    this.selectedCompanyProfileStatusId = undefined;
    this.selectedCompanyDetailStatus ="";
    this.selectedCompanyDetailStatusId = undefined;
    this.selectedDeliveryTeamStatus ="";
    this.selectedDeliveryTeamStatusId = undefined;
    this.selectedReferenceStatus ="";
    this.selectedReferenceStatusId = undefined;
    this.selectedAdminDetailStatus ="";
    this.selectedAdminDetailStatusId = undefined;
    this.selectedOnboardingDocumentStatus ="";
    this.selectedOnboardingDocumentStatusId = undefined;
    //  this.applyFilter();
    this.getVendorProfileStatusList();
  }
  applyFilter()
  {
    if (Object.keys(this.filters).length > 1)
    {
      this.appliedFilters = [];
    for(let i=0;i<this.filterCondition.length;i++)
    {
      if(this.filterCondition[i].type == "checkbox")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value == true)
        {
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"true"}) 
        }
        else if (this.filters[this.filterCondition[i].fieldName][0].value == false){
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"false"}) 
        }
      }
      else if (this.filterCondition[i].type == "basic")
      {
        if(this.filters[this.filterCondition[i].fieldName] !=undefined )
        {
          if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:this.filters[this.filterCondition[i].fieldName][0].value }) 
        }
      }
      else if (this.filterCondition[i].type == "date")
      {
        if(this.filters[this.filterCondition[i].fieldName] !=undefined )
        {
          for(let j=0; j<= this.filters[this.filterCondition[i].fieldName].length-1; j++)
          {
            if(this.filters[this.filterCondition[i].fieldName][j].value !== null)
            this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                      matchMode:this.filters[this.filterCondition[i].fieldName][j].matchMode,
                                      value: this.datePipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")}) 
          }
         
        }
       
      }
      else if (this.filterCondition[i].type == "numeric")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
        this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                  matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                  value:this.filters[this.filterCondition[i].fieldName][0].value }) 
      }
      else if (this.filterCondition[i].type == "dropdown") {
        if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
            if(this.filterCondition[i].fieldName != "All")
            {
              this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value
            })}
          }
        }
      }
      else if (this.filterCondition[i].type == "customdropdown") {
        if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
            if(this.filterCondition[i].fieldName != "All")
            {
              this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value.description
            })}
          }
        }
      }
      
    }
    }

    //////////////////
      
    this.searchGlobalFilter = [];
      

    ///////////////////

    //if(this.startSearch == true)
    if(this.startSearch == true || this.startSearch == false)
    {
      this.vendorProfileStatusSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
      this.spinner.show(this.vendorProfileStatusSearchSpinner);
      this.companyApprovalService.getVendorProfileStatusList(this.vendorProfileStatusSearchParam).subscribe((data: any) => {
      //this.appliedFilters = [];
      this.vendorProfileStatusList =data;
      console.log(this.vendorProfileStatusList);
      this.isshowpaginator=this.vendorProfileStatusList.length>0?true:false;
      console.log(this.vendorProfileStatusList);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.vendorProfileStatusSearchSpinner);
      });
    }
  }

  getCompanyProfileStatusOnChange(event)
  {
   this.selectedCompanyProfileStatusId= event.value;
   this.selectedCompanyProfileStatus=event.value;
  }
 
  clearCompanyProfileStatus()
  {
   this.selectedCompanyProfileStatus ="";
   this.selectedCompanyProfileStatusId = undefined;
  }

  getCompanyDetailStatusOnChange(event)
  {
   this.selectedCompanyDetailStatusId= event.value;
   this.selectedCompanyDetailStatus=event.value;
  }
 
  clearCompanyDetailStatus()
  {
   this.selectedCompanyDetailStatus ="";
   this.selectedCompanyDetailStatusId = undefined;
  }

  getDeliveryTeamStatusOnChange(event)
  {
   this.selectedDeliveryTeamStatusId= event.value;
   this.selectedDeliveryTeamStatus=event.value;
  }
 
  clearDeliveryTeamStatus()
  {
   this.selectedDeliveryTeamStatus ="";
   this.selectedDeliveryTeamStatusId = undefined;
  }

  getReferenceStatusOnChange(event)
  {
   this.selectedReferenceStatusId= event.value;
   this.selectedReferenceStatus=event.value;
  }
 
  clearReferenceStatus()
  {
   this.selectedReferenceStatus ="";
   this.selectedReferenceStatusId = undefined;
  }

  getAdminDetailStatusOnChange(event)
  {
   this.selectedAdminDetailStatusId= event.value;
   this.selectedAdminDetailStatus=event.value;
  }
 
  clearAdminDetailStatus()
  {
   this.selectedAdminDetailStatus ="";
   this.selectedAdminDetailStatusId = undefined;
  }

  getOnboardingDocumentStatusOnChange(event)
  {
   this.selectedOnboardingDocumentStatusId= event.value;
   this.selectedOnboardingDocumentStatus=event.value;
  }
 
  clearOnboardingDocumentStatus()
  {
   this.selectedOnboardingDocumentStatus ="";
   this.selectedOnboardingDocumentStatusId = undefined;
  }

  exportVendorProfileStatus() {
    this.applyFilter();
    this.vendorProfileStatusSearchParam = 
     {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      searchGlobalFilter: this.searchGlobalFilter,
      sortOrder:this.sortOrder
     };
     this.companyApprovalService.ExportVendorProfileStatusResult(this.vendorProfileStatusSearchParam).subscribe(res => {
     var blob = new Blob([res.body], { type: res.body.type });
     const file = new File([blob],"VendorProfileStatus.xlsx", { type: res.body.type });
     fs.saveAs(file);
     });
  }
  
}
